"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageSelect = void 0;
var LanguageSelect_1 = require("./LanguageSelect");
Object.defineProperty(exports, "LanguageSelect", { enumerable: true, get: function () { return LanguageSelect_1.LanguageSelect; } });
